<div #publisherDiv class="publisher box-shadow-1"></div>